import React, { FC } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/app/hooks";
import { selectUtil } from "../../Redux/features/utilsSlice";
import {
  getPaymentsFormDetails,
  selectPayment,
} from "../../Redux/features/paymentSlice";
import ReactSuiteDropdown from "../../Components/Form/Dropdowns/NewDropdown";
import { filter } from "../../Pages/PrivatePages/util";
import FilterButtons from "./FilterButtons";
import { levelOptions } from "../../Pages/PrivatePages/Hostels/util";

interface FilterSectionProps {
  filterFunction?: any;
  resetFilterFunction?: any;
}

const FilterSection: FC<FilterSectionProps> = ({
  filterFunction,
  resetFilterFunction,
}) => {
  const {
    sessions,
    semesters,
    faculties,
    paymentMean,
    feeSchedule,
    departments,
  } = useAppSelector(selectUtil);
  const {
    SessionId,
    SemesterId,
    DepartmentId,
    FacultyId,
    FeeScheduledId,
    LevelId,
  } = useAppSelector(selectPayment);
  const dispatch = useAppDispatch();

  const sessionFilter = filter(sessions, "sessionName", "sessionId");
  const facultyFilter = filter(faculties, "facultyName", "facultyId");
  const semesterFilter = filter(semesters, "semesterName", "semesterId");
  // const paymentMeanFilter = filter(paymentMean, "name", "id");
  const feeScheduleFilter = filter(
    feeSchedule,
    "feeScheduleName",
    "feeScheduleId"
  );

  const departmentFilter = filter(
    departments,
    "departmentName",
    "departmentId"
  );

  const handleSelect = (name: string, value: string | number) => {
    dispatch(getPaymentsFormDetails({ name, value }));
  };

  return (
    <div className="flex-centered-items flex-wrap">
      <ReactSuiteDropdown
        dropdownItems={facultyFilter}
        title={`Faculty`}
        handleDropdownSelect={handleSelect}
        name="FacultyId"
        value={FacultyId}
      />
      <ReactSuiteDropdown
        dropdownItems={departmentFilter}
        title={`Department`}
        handleDropdownSelect={handleSelect}
        name="DepartmentId"
        value={DepartmentId}
      />
      <ReactSuiteDropdown
        dropdownItems={sessionFilter}
        title={`Session`}
        handleDropdownSelect={handleSelect}
        name="SessionId"
        value={SessionId}
      />

      {/* <ReactSuiteDropdown
        dropdownItems={paymentMeanFilter}
        title={`payment Mean`}
        handleDropdownSelect={handleSelect}
        name="PaymentMeans"
        value={PaymentMeans}
      /> */}
      <ReactSuiteDropdown
        dropdownItems={feeScheduleFilter}
        title={`Fee Scheduled`}
        handleDropdownSelect={handleSelect}
        name="FeeScheduledId"
        value={FeeScheduledId}
      />
      <ReactSuiteDropdown
        dropdownItems={semesterFilter}
        title={`Semester`}
        handleDropdownSelect={handleSelect}
        name="SemesterId"
        value={SemesterId}
      />
      <ReactSuiteDropdown
        dropdownItems={levelOptions}
        title={`Level`}
        handleDropdownSelect={handleSelect}
        name="LevelId"
        value={LevelId}
      />
      <FilterButtons
        filterFunction={filterFunction}
        resetFilterFunction={resetFilterFunction}
      />
    </div>
  );
};

export default FilterSection;
